import {booking} from "./feature.booking.svelte.js";
import DateTimeUtil from "../../utils/DateTimeUtil";

import * as booking_scenarios_time from "./booking.scenarios.update.time.svelte.js";
import * as booking_select from "./booking.scenarios.select.svelte.js";
import * as booking_update from "./booking.scenarios.update.svelte.js";

// de rest komt uit andere delen van de datalaag.. je zou zeggen dat dan alles via de actions van die feature moet
import * as products_update from "../products/products.scenarios.update.svelte.js";
import DataLayerUtil from "../../utils/DataLayerUtil";
import {BUYABLE_TYPE_NON_PACKAGEDEAL, BUYABLE_TYPE_PACKAGEDEAL} from "../../AppConstants";
import * as packagedeals_select from "../packagedeals/packagedeals.scenarios.select.svelte.js";
import * as products_select from "../products/products.scenarios.select.svelte.js";
import {v4 as uuidv4} from "uuid";
import * as debug_actions from "../debug/actions_debug.svelte.js";
import * as progress_actions from "../progress/actions_progress.svelte.js";
import * as booking_actions from "./actions_booking.svelte.js";
import * as products_actions from "../products/actions_products.svelte.js";
import {progress} from "../progress/feature.progress.svelte.js";

export function scenarioSetNrOfPeople(iRequestedNrOfPeople)
{
  if ( typeof iRequestedNrOfPeople !== "number" || iRequestedNrOfPeople < 1 ) return;

  const lPeople = booking.lPeople;
  let iCurrentNrOfPeople = lPeople.length;

  if ( iRequestedNrOfPeople > iCurrentNrOfPeople )
  {
    const dif = iRequestedNrOfPeople - iCurrentNrOfPeople;
    for ( let i = 0; i < dif; ++i )
    {
      booking_update.addPerson();
    }
  }
  else if ( iRequestedNrOfPeople < iCurrentNrOfPeople )
  {
    const dif = iCurrentNrOfPeople - iRequestedNrOfPeople;
    for ( let i = 0; i < dif; ++i )
    {
      booking_update.removeLastAddedPerson();
    }
  }

  //booking_scenarios_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('scenarioSetNrOfPeople');
}

export function scenarioAddPerson()
{
  booking_update.addPerson();
  //booking_scenarios_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('scenarioAddPerson');
}

export function scenarioSetArrivalDate(iDay, iMonth, iYear)
{
  //window.console.log('scenarioSetArrivalDate', iDay, iMonth, iYear);
  const oDate = DateTimeUtil.getDateFromParts(iDay, iMonth, iYear);
  if ( oDate )
  {
    const sDate = DateTimeUtil.getStringFromDate(oDate);

    if ( !DateTimeUtil.isDateInPast(sDate) )
    {
      let sDay = iDay + "";

      if ( sDay.length < 2 )
      {
        sDay = "0" + sDay;
      }

      let sMonth = iMonth + "";

      if ( sMonth.length < 2 )
      {
        sMonth = "0" + sMonth;
      }

      let sYear = iYear + "";
      booking.sArrivalDate = sDate;
      booking.iArrivalDay = iDay;
      booking.sArrivalDay = sDay;
      booking.iArrivalMonth = iMonth;
      booking.sArrivalMonth = sMonth;
      booking.iArrivalYear = iYear;
      booking.sArrivalYear = sYear;
    }
  }

  booking_update.handlePostDateSelectActions();
}

export function handlePostDateSelectActions()
{
  // deze functie wordt getriggerd vanuit scenarioSetArrivalDate als je in de kalender expliciet een datum kiest
  // maar ook vanuit de goToNext functie op het moment dat iemand niets aanklikt in de kalender en tevreden is met de preset
  // datum van vandaag

  // booking_update.removePackageDealsForEveryone(); <--- ik weetn iet meer waarom dit er stond, maar het gooide de preset arrangementen weer uit de boeking
  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  // booking_scenarios_receipt.calculateBookingTotals();
  // booker_update.reevaluateAllowedPaymentMethods();
  booking_actions.handleBookingUpdated('handlePostDateSelectActions');

  // doe de behandelingen VOOR de arrangementen
  // de reden is dat we de arrangementen een lange call is en we die ook opvragen op de niet arrangementenroute
  // voor het geval iemand daarna terug gaat naar stap 1 en toch nog switcht.. door behandelingen eerst te doen kunnen
  // de niet-arrangement bezoekers sneller door.
  progress_actions.apiCallRequestTreatments();
  progress_actions.apiCallRequestPackageDeals();
}

export function scenarioSetArrivalDateByString(sDate)
{
  return;
  //window.console.log('scenarioSetArrivalDate by string', sDate);
  //window.console.log('scenarioSetArrivalDateByString', sDate);
  // if ( !DateTimeUtil.isDateInPast(sDate) )
  // {
  booking.sArrivalDate = sDate;
  // }

  booking_update.handlePostDateSelectActions();
}

export function scenarioClearArrivalTime()
{
  booking.iArrivalTime = false;
  booking.sArrivalTime = false;
  booking.iArrivalHour = false;

  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_update.resetDinnerPreference();
  //console.log('trigger updateNextButtonState scenarioClearArrivalTime');
  progress_actions.updateNextButtonState();
}

export function scenarioClearDepartureTime()
{
  booking.iDepartureTime = false;
  booking.sDepartureTime = false;
  booking.iDepartureHour = false;

  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_update.resetDinnerPreference();
  //console.log('trigger updateNextButtonState scenarioClearDepartureTime');
  progress_actions.updateNextButtonState();
}

export function scenarioSetArrivalTime(iTime, bSkipAdjustTimesToPreventRecursion = false)
{
  booking_update.removeAllTimeSlotChoices();

  if ( iTime === false )
  {
    booking.iArrivalTime = false;
    booking.sArrivalTime = false;
    booking.iArrivalHour = false;
    return;
  }

  booking.iArrivalTime = parseInt(iTime);
  booking.sArrivalTime = DateTimeUtil.getTimeAsStringWithSemicolonFromJoinedHoursMinInt(booking.iArrivalTime);

  let sTime = DateTimeUtil.getTimeAsStringWithSemicolonFromJoinedHoursMinInt(booking.iArrivalTime);

  if ( sTime.length > 0 )
  {
    let aTimeParts = sTime.split(":");

    if ( aTimeParts.length > 1 )
    {
      booking.iArrivalHour = parseInt(aTimeParts[0]);
    }
  }

  if ( bSkipAdjustTimesToPreventRecursion !== true )
  {
    booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  }

  booking_update.resetDinnerPreference();
  booking_update.evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange();

  //console.log('trigger updateNextButtonState scenarioSetArrivalTime');
  progress_actions.updateNextButtonState();
}


export function evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange()
{
  // pas op dat je hier niet in een loop van correcties komt als entrees op tijden reageren en tijden weer op entrees
  // dus hou het hier simpel.. switch alleen de 2 uurs entree en de dagentree en alleen als het overdag is buiten de tijden
  // van de avondentree

  if ( booking.bIsAction === true )
  {
    // niets doen als dit een actie is
    return;
  }

  // niets doen als er nog geen Step14 selectie is gemaakt (entree subtype of badenkaart type)
  // dit voorkomt dat we te vroeg al een entry product toevoegen
  if ( booking.bStep14SelectionMade !== true )
  {
    return;
  }

  // niets doen als we een arrangement hebben
  if ( booking_select.getPersonWithPackageDeal() )
  {
    return;
  }

  // maken de tijden dat we een korte entree kunnen gebruiken?
  let iSpecialMainEntryIDToUse = booking_select.doCurrentBookingAndBookerValuesSuggestASpecialEntryProduct();

  // als de entree anders moet zijn dan wisselen we die - door het product toe te voegen wordt de oude entree er uit gekegeld
  if ( iSpecialMainEntryIDToUse )
  {
    booking_update.scenarioAddProduct(iSpecialMainEntryIDToUse);
    return;
  }

  booking_update.scenarioAddProduct(booking_select.getEntryBuyableIDForPartOfDayPreference(booking.sPreferredPartOfTheDay));
}

export function scenarioSetDepartureTime(iTime, bSkipAdjustTimesToPreventRecursion = false)
{
  booking_update.removeAllTimeSlotChoices();

  if ( iTime === false )
  {
    booking.iDepartureTime = false;
    booking.sDepartureTime = false;
    booking.iDepartureHour = false;
    return;
  }

  booking.iDepartureTime = parseInt(iTime);
  booking.sDepartureTime = DateTimeUtil.getTimeAsStringWithSemicolonFromJoinedHoursMinInt(booking.iDepartureTime);

  let sTime = DateTimeUtil.getTimeAsStringWithSemicolonFromJoinedHoursMinInt(booking.iDepartureTime);

  if ( sTime.length > 0 )
  {
    let aTimeParts = sTime.split(":");

    if ( aTimeParts.length > 1 )
    {
      booking.iDepartureHour = parseInt(aTimeParts[0]);
    }
  }

  if ( bSkipAdjustTimesToPreventRecursion !== true )
  {
    booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  }

  booking_update.resetDinnerPreference();
  booking_update.evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange();

  //console.log('trigger updateNextButtonState scenarioSetDepartureTime');
  progress_actions.updateNextButtonState();
}

export function scenarioSetPreferredPartOfDay(sPreferredPartOfTheDay)
{
  booking.sPreferredPartOfTheDay = sPreferredPartOfTheDay;
  booking_update.evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange();
  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_actions.handleBookingUpdated('scenarioSetPreferredPartOfDay');
}

export function scenarioSetPreferredEntryType(sPreferredEntryType)
{
  booking.sSelectedEntryType = sPreferredEntryType;
  booking_update.evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange();
  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_actions.handleBookingUpdated('scenarioSetPreferredEntryType');

}

export function scenarioSetWantsDinner(bWantsDinner)
{
  booking.bWantsDinner = bWantsDinner;
}

export function resetDinnerPreference()
{
  booking_update.scenarioSetPreferredDinnerTime("");
  booking_update.scenarioSetWantsDinner(false);
}

export function scenarioSetPreferredDinnerTime(sPreferredTime)
{
  booking.sPreferredDinnerTime = sPreferredTime;
}

export function scenarioAddOrReplacePackageDeal(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);

  booking.lPeople.forEach((oPerson) => {
    booking_update.addPackageDealToPerson(oPerson.sID, iPackageDealID, true);
  });

  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_actions.handleBookingUpdated('scenarioAddOrReplacePackageDeal');
  DataLayerUtil.eventSelectPackageDeal(iPackageDealID);
}

export function scenarioRemovePackageDeal()
{
  booking_update.removePackageDealsForEveryone();
  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_actions.handleBookingUpdated('scenarioRemovePackageDeal');
}

export function scenarioAddPackageDealProductToPerson(iPersonID = false, iPackageDealID = false, iBuyableID = false, iChoiceID = false)
{
  if ( typeof iPersonID === 'undefined' || iPersonID === false || typeof iPackageDealID === 'undefined' || iPackageDealID === false || typeof iBuyableID === 'undefined' || iBuyableID === false || typeof iChoiceID === 'undefined' || iChoiceID === false ) return;
  const aPeopleState = booking.lPeople;

  let oPerson = aPeopleState.find((oCurrentPerson) => {
    return oCurrentPerson.sID === iPersonID;
  });

  if ( oPerson )
  {
    // console.log('scenarioAddPackageDealProductToPerson A', iChoiceID);
    booking_update.addProductToPerson(oPerson.sID, iBuyableID, iPackageDealID, iChoiceID);
  }

  booking_actions.handleBookingUpdated('scenarioAddPackageDealProductToPerson');
}

export function scenarioAddProduct(iProductID, sOptionalPersonID = false)
{
  iProductID = parseInt(iProductID);
  const aPeople = sOptionalPersonID
    ? booking.lPeople.filter((person) => person.sID === sOptionalPersonID)
    : booking.lPeople;

  // Als dit een entree is dan willen we een eventuele dagprijs uit de kalenderdata laden
  if ( products_select.isEntryProduct(iProductID) === true )
  {
    let sCurrentDate = booking.iArrivalYear + '-' + booking.iArrivalMonth + '-' + booking.iArrivalDay;
    let sCurrentDateWithZeroes = booking.sArrivalDate;

    if ( typeof progress?.aCalendarDates[sCurrentDate] !== 'undefined' && typeof progress.aCalendarDates[sCurrentDate]['p_' + iProductID] !== "undefined" )
    {
      products_actions.updateProductPriceForDay({
        iPrice: progress?.aCalendarDates[sCurrentDate]['p_' + iProductID],
        iBuyableID: iProductID,
        sStartDate: sCurrentDateWithZeroes
      });
    }
  }

  // nu de prijzen goed staan kunnen we het product toevoegen - mocht je een entree toevoegen dan kegelt die een bestaande entree er uit
  aPeople.forEach((oPerson) => {
    //window.console.log('tempdebug', mPerson.sID, iProductID);
    booking_update.addProductToPerson(oPerson.sID, iProductID);
  });

  booking_update.resetBadenkaart();
  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  booking_actions.handleBookingUpdated('scenarioAddProduct');
}

export function scenarioAddGiftcard(iGiftCardValue, sGiftCardCode)
{
  // console.log('scenarioAddGiftcard 1', iGiftCardValue);
  if ( parseInt(iGiftCardValue) > 0 )
  {
    // console.log('scenarioAddGiftcard 2', iGiftCardValue);
    const sID = uuidv4();
    const oGiftCardCode = {
      sID,
      sCode: sGiftCardCode,
      iValue: iGiftCardValue / 100,
      iValueCents: iGiftCardValue
    };

    booking.lValidGiftcardCodes.push(oGiftCardCode);
    booking_update.calculateTotalGiftcardValue();
  }
}

export function calculateTotalGiftcardValue()
{
  let iTotalGiftcardValue = 0;
  booking.lValidGiftcardCodes.forEach((code) => {
    iTotalGiftcardValue += code.iValueCents;
  });

  booking.iValidGiftcardValue = iTotalGiftcardValue;
}

export function scenarioSetShowPackageDeals(bShowListOfPackageDeals)
{
  booking.bShowListOfPackageDeals = bShowListOfPackageDeals;
}

export function scenarioRemoveProduct(iProductID, sOptionalPersonID = false)
{
  iProductID = parseInt(iProductID);

  const aPeople = sOptionalPersonID
    ? booking.lPeople.filter((person) => person.sID === sOptionalPersonID)
    : booking.lPeople;

  aPeople.forEach((person) => {
    booking_update.removeProductForPerson(person.sID, iProductID);
    booking_update.addAppropriateEntryForPersonIfNeeded(person.sID);
  });

  booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
  // booking_scenarios_receipt.calculateBookingTotals();
  // booker_update.reevaluateAllowedPaymentMethods();
  booking_actions.handleBookingUpdated('scenarioRemoveProduct');
}

export function scenarioAddBadenkaart(iBadenkaartValue, sBadenkaartCode)
{
  const sID = uuidv4();
  booking.lValidBadenkaartCodes.push({
    sID,
    sCode: sBadenkaartCode,
    iValue: iBadenkaartValue / 100,
    iValueCents: iBadenkaartValue
  });

  booking.lRemovedBadenkaartCodes = booking.lRemovedBadenkaartCodes.filter(
    (removedCode) => removedCode.sCode !== sBadenkaartCode
  );

  booking_update.calculateTotalBadenkaartValue();
}

export function calculateTotalBadenkaartValue()
{
  booking.iValidGiftcardValue = booking.lValidBadenkaartCodes.reduce((sum, code) => sum + code.iValueCents, 0);
}

export function evaluateGifcardCodeValidity(sGiftCardCode)
{
  if ( typeof sGiftCardCode === 'string' )
  {

    booker.sGiftCardCode = sGiftCardCode;

    if ( !sGiftCardCode.length === 13 )
    {
      booking.sGiftCardError = 'De opbouw van dit cadeaubonnummer wordt niet herkend.';
    }
  }
}

export function resetGiftcard()
{
  booking.lValidGiftcardCodes = [];
  booking.iValidGiftcardValue = null;
  booking.sGiftCardError = null;
}

export function resetBadenkaart()
{
  booking.lRemovedBadenkaartCodes.push(...booking.lValidBadenkaartCodes);
  booking.lValidBadenkaartCodes = [];
  booking.sBadenkaartError = null;
}

// export function resetBadenkaart()
// {
//   booking.lValidBadenkaartCodes.forEach((code) => {
//     booking.lRemovedBadenkaartCodes.push(code);
//   });
//
//   booking.lValidBadenkaartCodes = [];
//   booking.iValidBadenkaartValue = null;
//   booking.sBadenkaartError = null;
// }

// Methods for updating state. Only called by reducers, reducer scenarios, and other updaters.
// These methods are never called directly from view components.

export function addPerson()
{
  const sID = uuidv4();
  const newPerson = {
    sID: sID,
    sName: 'Gast ' + (booking.lPeople.length + 1),
    lBookedPackageDeals: [],
    lBookedBuyables: []
  };

  booking.lPeople.push(newPerson);

  // Welke entree of welk arrangement krijgt deze persoon?
  // Als er een preselected arrangement is meegegeven dan wordt daar rekening mee gehouden en daarmee is dat afgehandeld.
  // Als er een preselected product (massage) is meegegeven dan moeten we die verderop nog toevoegen want het gaat hier meer
  // om hoe je binnenkomt (arrangement/entree).
  const oBuyableToAdd = booking_select.getBuyableToAddForNewPeople();

  if ( oBuyableToAdd )
  {
    const {sBuyableType, iBuyableID} = oBuyableToAdd;
    products_update.scenarioUpdateProductPriceForTodayWithoutRemoteCheck(iBuyableID);

    if ( iBuyableID && sBuyableType === BUYABLE_TYPE_NON_PACKAGEDEAL )
    {
      //console.log('addPerson - entree ' + sBuyableType + ' ' + iBuyableID);
      booking_update.addAppropriateEntryForPersonIfNeeded(sID);
    }
    else if ( sBuyableType === BUYABLE_TYPE_PACKAGEDEAL )
    {
      // console.log('addPerson - arrangement ' + sBuyableType + ' ' + iBuyableID);
      booking_update.scenarioAddOrReplacePackageDeal(iBuyableID);
    }
    else
    {        // dit is nodig als je binnenkomt met een arrangement preselection
      // we voegen dan geen entree toe, maar ook nog niet die packagedeal
      //console.log('addPerson - ??? ' + sBuyableType);
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
    }
  }

  //console.log('test afhandeling iPreselectedTreatmentID 1');
  // afhandelen preselected product (arrangement is al afgehandeld)
  if ( booking.iPreselectedTreatmentID !== false )
  {
    //console.log('test afhandeling iPreselectedTreatmentID 2');
    products_update.scenarioUpdateProductPriceForTodayWithoutRemoteCheck(booking.iPreselectedTreatmentID);
    booking_update.addProductToPerson(sID, booking.iPreselectedTreatmentID);
  }
  else
  {
    //console.log('test afhandeling iPreselectedTreatmentID 3');
  }
}

export function addAppropriateEntryForPersonIfNeeded(personID)
{
  const oBuyableToAddForNewPeople = booking_select.getBuyableToAddForNewPeople();
  //window.console.log('addAppropriateEntryForPersonIfNeeded', oBuyableToAddForNewPeople);
  if ( oBuyableToAddForNewPeople )
  {
    const {sBuyableType, iBuyableID} = oBuyableToAddForNewPeople;
    if ( iBuyableID && sBuyableType === BUYABLE_TYPE_NON_PACKAGEDEAL )
    {
      booking_update.scenarioAddProduct(iBuyableID, personID);
    }
    else if ( sBuyableType === BUYABLE_TYPE_PACKAGEDEAL )
    {	// sa (sauna arr)
      // voor hier niet relevant
      // booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
    }
  }
}

export function removeLastAddedPerson()
{
  booking.lPeople.pop();
}

export function addPackageDealToPerson(sPersonID, iPackageDealID)
{
  const oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);

  debug_actions.debugAddLogFlow('booking_update', 'addPackageDealToPerson', {
    iPackageDealID: iPackageDealID,
    oPackageDeal: oPackageDeal
  });

  if ( oPackageDeal )
  {
    booking_update.removePackageDealsForPerson(sPersonID);
    booking_update.removeEntriesForPerson(sPersonID);

    const iPersonIndex = booking.lPeople.findIndex(oPerson => oPerson.sID === sPersonID);
    if ( iPersonIndex === -1 ) return;

    //console.log('addPackageDealToPerson ARRA', iPackageDealID, sPersonID);
    // console.log("HIER ARRA TOEVOEGEN", iPersonIndex);
    booking.lPeople[iPersonIndex].lBookedPackageDeals.push({
      iID: iPackageDealID
      // nAlternatePrice - een andere prijs in deze bestelling dan de normale basisprijs
    });

    // console.log("HIER ARRA TOEGEVOEGD", $state.snapshot(booking.lPeople[iPersonIndex].lBookedPackageDeals));

    // de basisproducten van deze packagedeal toevoegen
    const aProducts = oPackageDeal.lProducts || [];
    aProducts.forEach(oProduct => {
      if ( !oProduct.iChoiceID )
      {
        booking_update.addProductToPerson(sPersonID, oProduct.iID, iPackageDealID, false);
      }
    });
  }

  booking.iCurrentSelectedPackagedealID = iPackageDealID;
}

export function removePackageDealsForEveryone()
{
  //console.log('removePackageDealsForEveryone');
  // dit is losgetrokken van de onderliggende removePackageDealsForPerson omdat we voor alle personen
  // het arrangement moeten verwijderen voordat we de nieuwe entrees toevoegen
  booking.lPeople.forEach(oPerson => {
    oPerson.lBookedPackageDeals = [];
    oPerson.lBookedBuyables = oPerson.lBookedBuyables.filter(item => !item.iAddedAsPartOfPackageDealID);
  });

  booking.iPreselectedPackageDealID = false; // als we eenmaal handmatig het arrangement verwijderen verbreken we de band met de preset zodat calendar calls de entreeprijzen ophalen
  booking.iCurrentSelectedPackagedealID = 0;

  booking.lPeople.forEach(oPerson => {
    booking_update.addAppropriateEntryForPersonIfNeeded(oPerson.sID);
  });
}

export function removePackageDealsForPerson(sPersonID)
{
  //console.log('removePackageDealsForPerson');
  const iPersonIndex = booking.lPeople.findIndex(oPerson => oPerson.sID === sPersonID);
  if ( iPersonIndex === -1 ) return;

  const oPerson = booking.lPeople[iPersonIndex];
  oPerson.lBookedPackageDeals = [];
  oPerson.lBookedBuyables = oPerson.lBookedBuyables.filter(item => !item.iAddedAsPartOfPackageDealID);

  booking_update.addAppropriateEntryForPersonIfNeeded(sPersonID);
}

export function removeEntriesForPerson(sPersonID)
{
  const iPersonIndex = booking.lPeople.findIndex(oPerson => oPerson.sID === sPersonID);
  if ( iPersonIndex === -1 ) return;

  const oPerson = booking.lPeople[iPersonIndex];
  oPerson.lBookedBuyables = oPerson.lBookedBuyables.filter(item => !products_select.isEntryProduct(item.iID));
}

export function removeInsurancesForEveryone()
{
  booking.lPeople.forEach(person => {
    booking_update.removeInsurancesForPerson(person.sID);
  });
}

export function removeInsurancesForPerson(sPersonID)
{
  const personIndex = booking.lPeople.findIndex(person => person.sID === sPersonID);
  if ( personIndex === -1 ) return;

  const oPerson = booking.lPeople[personIndex];
  oPerson.lBookedBuyables = oPerson.lBookedBuyables.filter(item => !products_select.isInsuranceProduct(item.iID));
}

export function removeNonPreselectedPackageDeals()
{
  booking.lPeople.forEach(person => {
    booking_update.removeNonPreselectedPackageDealsForPerson(person.sID);
  });
}

export function removeNonPreselectedPackageDealsForPerson(sPersonID)
{
  if ( booking.iPreselectedPackageDealID === false )
  {
    // er was geen preselected arrangement, dan gaat het arrangement er uit
    booking_update.removePackageDealsForEveryone();
  }
}

export function removeUnavailableTreatments()
{
  booking.lPeople.forEach(person => {
    booking_update.removeUnavailableTreatmentsForPerson(person.sID);
  });
}

export function removeUnavailableTreatmentsForPerson(sPersonID)
{
  // Alle niet choiceid 0 behandelingen weg die bIsAvailable !== true
  // Daardoor moet je al je keuzes opnieuw doen in een arrangement en je losse behandelingen opnieuw kiezen.
  // Het arrangement gaat er ook uit TENZIJ je de reserveerstraat binnen bent gekomen met het arrangement preselected
  // want in dat geval heeft de kalender alleen maar datums getoond waarop het arrangement beschikbaar is (via de calendar call bIsAvailable)

  // Producten
  const personIndex = booking.lPeople.findIndex(person => person.sID === sPersonID);
  if ( personIndex === -1 ) return;

  const oPerson = booking.lPeople[personIndex];

  oPerson.lBookedBuyables.forEach((oBuyable) => {
    // oBuyable.iID
    // oBuyable.oTimeSlot
    // oBuyable.iAddedAsPartOfPackageDealID (false/id)
    // oBuyable.iChoiceIDInPackageDeal (0 is niet verwijderbaar)
    let oProductExtraData = products_select.getProductInfoFromAvailableTreatmentsByID(oBuyable.iID);

    let bIsAvailable = true;
    if ( !oProductExtraData )
    {
      bIsAvailable = false;
    }
    else if ( oProductExtraData.bIsAvailable !== true )
    {
      bIsAvailable = false;
    }

    if ( booking.iPreselectedTreatmentID === oBuyable.iID )
    {
      if ( bIsAvailable === true )
      {
        // terugzetten voor het geval iemand een nieuwe datum heeft gekozen
        progress.bThereWasAPreselectedTreatmentButItIsNotAvailable = false;
        progress.bShowMessageThereWasAPreselectedTreatmentButItIsNotAvailable = false;
      }
      else
      {
        progress.bThereWasAPreselectedTreatmentButItIsNotAvailable = true;
        progress.bShowMessageThereWasAPreselectedTreatmentButItIsNotAvailable = true;
      }
    }

    // Alleen houden als:
    // - product bIsAvailable
    // - OF product is geboekt als onderdeel van een arrangement in iChoiceID === 0 (vast onderdelen kunnen we niet uit een arrangement zetten)
    if ( bIsAvailable === true
      || (oBuyable.iAddedAsPartOfPackageDealID === true && oBuyable.iChoiceIDInPackageDeal === 0)
    )
    {
      // houden
    }
    else
    {
      // WEG
      // 1 uitzondering.. we willen niet de entree er uit kieperen dus we moeten even checken of het een entree is
      if ( products_select.isEntryProduct(oBuyable.iID) !== true )
      {
        // geen entree -> weg ermee
        booking_update.removeProductForPerson(sPersonID, oBuyable.iID);
      }
    }
  });
}

export function removeAllTimeSlotChoices()
{
  booking.lPeople.forEach(person => {
    booking_update.removeAllTimeSlotChoicesForPerson(person.sID);
  });
}

export function removeAllTimeSlotChoicesForPerson(sPersonID)
{
  // bij binnenkomen nieuwe behandeldata voor de dag dan alle tijden bij behandelingen clearen
  const lPeople = booking.lPeople;
  const iPersonIDX = lPeople.findIndex((mPersonInlPeople) => {
    // console.log(mPersonInlPeople.get('sID'), sPersonID);
    return mPersonInlPeople.sID === sPersonID;
  });

  if ( iPersonIDX === -1 ) return;

  booking.lPeople[iPersonIDX].lBookedBuyables.forEach((oBookedProductConfig) => {
    const idx = booking.lPeople[iPersonIDX].lBookedBuyables.findIndex(oItem => oItem.iID === oBookedProductConfig.iID);
    booking.lPeople[iPersonIDX].lBookedBuyables[idx].oTimeSlot = {L: "", V: 'x'};
  });
}

export function changeTimeSlot(sPersonID, iBuyableID, sTimeSlotValue, sTimeSlotLabel)
{
  const lPeople = booking.lPeople;
  const iPersonIDX = lPeople.findIndex((mPersonInlPeople) => {
    // console.log(mPersonInlPeople.get('sID'), sPersonID);
    return mPersonInlPeople.sID === sPersonID;
  });

  if ( iPersonIDX === -1 ) return;

  const oProduct = products_select.getProductByID(iBuyableID);

  if ( oProduct )
  {
    let bIsProductPresentInBooking = booking.lPeople[iPersonIDX].lBookedBuyables.some((oBookedProductConfig) => {
      return oBookedProductConfig.iID === iBuyableID;
    });

    if ( bIsProductPresentInBooking === true )
    {
      const iPersonProductIDX = booking.lPeople[iPersonIDX].lBookedBuyables.findIndex((oBookedProductConfig) => {
        // console.log(mPersonInlPeople.get('sID'), sPersonID);
        return oBookedProductConfig.iID === iBuyableID;
      });

      if ( iPersonProductIDX === -1 ) return;

      booking.lPeople[iPersonIDX].lBookedBuyables[iPersonProductIDX].oTimeSlot = {
        V: sTimeSlotValue,
        L: sTimeSlotLabel
      };
    }
  }

  // booking_update_receipt.calculateBookingTotals(); // triggert ook het opnieuw generen van de BookingSummary met de tijdsloten
  booking_actions.handleBookingUpdated('changeTimeSlot');
}

export function addProductToPerson(
  sPersonID,
  iBuyableID,
  iAddedAsPartOfPackageDealID = false,
  iChoiceIDInPackageDeal      = false,
  oTimeSlot                   = {L: "", V: 'x'} // x = 'nog geen input' y = 'deel me maar ergens in' - overige waardes zijn gekozen tijdslots
)
{
  //console.log('addProductToPerson-oBuyableToAdd:', sPersonID, iBuyableID);

  // console.log('addProductToPerson', sPersonID, iBuyableID);
  let bProceedWithAddingOfProduct = true;
  if ( iChoiceIDInPackageDeal === 0 || iChoiceIDInPackageDeal === '0' ) iChoiceIDInPackageDeal = false;

  const lPeople = booking.lPeople;
  const iPersonIDX = lPeople.findIndex((mPersonInlPeople) => {
    // console.log(mPersonInlPeople.get('sID'), sPersonID);
    return mPersonInlPeople.sID === sPersonID;
  });

  if ( iPersonIDX === -1 ) return;
  const oProduct = products_select.getProductByID(iBuyableID);

  // product niet toevoegen als deze persoon hem al heeft.. we ondersteunen op dit moment nergens een 2e keer iets kopen en het maakt entrees makkelijker
  if ( oProduct )
  {
    //console.log('addProductToPerson-mProduct:', $state.snapshot(oProduct));
    let bIsActionBooking = false;
    let bIsFirstPersonInBooking = false;
    let bIsFirstEntryOfFirstPerson = false;
    let aBookedBuyables = booking.lPeople[iPersonIDX].lBookedBuyables;

    // verwijder oude entree als het nieuwe product een entree is
    if ( products_select.isEntryProduct(iBuyableID) === true )
    {
      // in principe moet een al eerder toegevoegde entree wijken als er
      // een andere wordt toegevoegd
      // hierop is 1 uitzondering.. als dit de boeking van een actie is en het hier de eerste persoon in de boeking betreft
      // in dat geval kun je die actie entree nooit kwijt raken zonder de pagina te herladen
      // we moeten alleen de eerste keer de actie entree wel kunnen toevoegen aan die eerste persoon

      if ( booking.bIsAction === true ) bIsActionBooking = true;

      if ( iPersonIDX === 0 )
      {
        bIsFirstPersonInBooking = true;

        // check of de persoon al producten heeft.. dat zou als je binnenkomt met een actie niet zo moeten zijn
        if ( aBookedBuyables.size === 0 )
        {
          bIsFirstEntryOfFirstPerson = true;
        }
      }

      // niet toevoegen als dit een actie is en je de entree van de eerste persoon wil aanpassen (behalve dan de eerste keer toevoegen bij het opstarten.. anders kun je nooit een actieentree hebben)
      if ( bIsActionBooking === true && bIsFirstPersonInBooking === true && bIsFirstEntryOfFirstPerson === false )
      {
        bProceedWithAddingOfProduct = false;
      }
    }

    if ( aBookedBuyables && bProceedWithAddingOfProduct === true )
    {   // een product kan maar 1 keer toe worden gevoegd per persoon - checken of product al in de order zit
      let bIsProductPresentInBookingAsPartOfPackageDeal = false;
      let bIsProductPresentInBooking = aBookedBuyables.some((item) => {
        return item.iID === iBuyableID;
      });

      // als we een entree willen toevoegen (en we hebben hierboven al gecheckt dat dit geen situatie is waarin we ivm actie entrees niet moeten toevoegen)
      // en we hebben deze entree niet al, dan verwijderen we andere entrees bij deze persoon
      if ( bIsProductPresentInBooking === false && products_select.isEntryProduct(iBuyableID) === true )
      {
        booking_update.removeEntriesForPerson(sPersonID);
      }

      if ( bIsProductPresentInBooking && iAddedAsPartOfPackageDealID !== false )
      {   // product is al toegevoegd en nu willen we hem weer als onderdeel van een arrangement toevoegen
        // dan moeten we controleren of hij al als onderdeel van het arrangement was toegevoegd of los
        bIsProductPresentInBookingAsPartOfPackageDeal = aBookedBuyables.some((oItem) => {
          return oItem.iID === iBuyableID && oItem.iAddedAsPartOfPackageDealID !== false;
        });
      }

      if ( bIsProductPresentInBooking === true && bIsProductPresentInBookingAsPartOfPackageDeal === false && iAddedAsPartOfPackageDealID !== false )
      {   // product verwijderen zodat we het zometeen opnieuw kunnen toevoegen als onderdeel van een arrangement
        aBookedBuyables = aBookedBuyables.filter((oItem) => {
          return iBuyableID !== oItem.iID
        });

        booking.lPeople[iPersonIDX].lBookedBuyables = aBookedBuyables;
      }

      // opnieuw controleren
      bIsProductPresentInBooking = aBookedBuyables.some((item) => {
        return item.iID === iBuyableID;
      });

      // ok, toevoegen
      //console.log('addProductToPerson-bIsProductPresentInBooking:', bIsProductPresentInBooking);
      if ( bIsProductPresentInBooking === false )
      {
        // als iChoiceIDInPackageDeal mee is gegeven dan moeten eventuele eerdere keuzes met diezelfde choice id worden verwijderd (per setje kan maar 1 keuze worden gemaakt)
        if ( iAddedAsPartOfPackageDealID && iChoiceIDInPackageDeal )
        {
          booking_update.removeAllProductsInPackageDealChoiceForPerson(sPersonID, iAddedAsPartOfPackageDealID, iChoiceIDInPackageDeal);

        }

        // toevoegen
        aBookedBuyables = booking.lPeople[iPersonIDX].lBookedBuyables;

        //console.log('addProductToPerson-lBookedBuyables0:', $state.snapshot(lBookedBuyables));
        booking.lPeople[iPersonIDX].lBookedBuyables.push({
          iID: iBuyableID,
          oTimeSlot: oTimeSlot,
          iAddedAsPartOfPackageDealID,
          iChoiceIDInPackageDeal //  - NB! als isChoice van het product op de PackageDeal '0' (of 0) is dan is het een vast onderdeel en dus niet verwijderbaar zolang dit arrangement er nog is
        });

        if ( products_select.isEntryProduct(iBuyableID) !== true )
        {
          // nu we een non-entry product in de mand kiepen hoeven we niet de tekst te blijven tonen dat er een product niet beschikbaar is
          progress.bShowMessageThereWasAPreselectedTreatmentButItIsNotAvailable = false;
        }

        if ( iAddedAsPartOfPackageDealID === false )
        {
          DataLayerUtil.eventSelectProduct(iBuyableID);
        }
        else
        {
          DataLayerUtil.eventSelectProductInPackageDeal(iBuyableID, iAddedAsPartOfPackageDealID);
        }
      }
    }
  }
  else
  {
    debug_actions.debugAddLogFlow('booking', 'addProduct niet gelukt omdat product niet gevonden kon worden', {iBuyableID});
  }
}

export function removeProductForPerson(sPersonID, iBuyableID)
{
  const iPersonIndex = booking.lPeople.findIndex(oPerson => oPerson.sID === sPersonID);
  if ( iPersonIndex === -1 ) return;

  const oPerson = booking.lPeople[iPersonIndex];
  oPerson.lBookedBuyables = oPerson.lBookedBuyables.filter(item => item.iID !== parseInt(iBuyableID));
}

export function removeAllProductsInPackageDealChoiceForPerson(sPersonID, iPackageDealID, iChoiceID)
{
  const iPersonIndex = booking.lPeople.findIndex(oPerson => oPerson.sID === sPersonID);
  if ( iPersonIndex === -1 ) return;

  const oPerson = booking.lPeople[iPersonIndex];
  oPerson.lBookedBuyables = oPerson.lBookedBuyables.filter(item =>
    item.iAddedAsPartOfPackageDealID !== iPackageDealID || item.iChoiceIDInPackageDeal !== iChoiceID
  );
}


